var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracoCurvo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 6,
    viewBox: "0 0 19 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.860458 0.03125C1.30439 0.03125 1.66427 0.39392 1.66427 0.841295V3.00142C1.66427 3.74704 2.26408 4.35149 3.00397 4.35149H15.865C16.6049 4.35149 17.2047 3.74704 17.2047 3.00142V0.841295C17.2047 0.39392 17.5646 0.03125 18.0086 0.03125C18.4525 0.03125 18.8124 0.39392 18.8124 0.841295V3.00142C18.8124 4.64179 17.4928 5.97158 15.865 5.97158H3.00397C1.3762 5.97158 0.0566406 4.64179 0.0566406 3.00142V0.841295C0.0566406 0.39392 0.416522 0.03125 0.860458 0.03125Z",
    fill: "#E4003A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracoCurvo);
export default __webpack_public_path__ + "static/media/tracoCurvo.68a65f6539ffb27a904259e0f3541a36.svg";
export { ForwardRef as ReactComponent };